/* global $$epiforms */

import ProductRegistration from "./product-registration.js";

if (typeof $$epiforms !== "undefined") {
    (function($) {
        $$epiforms(".EPiServerForms")
            .on("formsSubmitted",
                function (e) {
                    var formName = $(e.currentTarget).attr("name");
                    formName = formName ? formName : e.workingFormInfo.Name;
                    const isProductRegForm = formName.includes("product-registration-form");
                    const hasEmbeddedForm = document.querySelector("[data-form-block-id]");

                    if (!isProductRegForm || !e.isSuccess || !hasEmbeddedForm) {
                        return;
                    }

                    if (e.isFinalizedSubmission && e.isSuccess) {
                        var elements = e.workingFormInfo.ElementsInfo;
                        var data = e.formData;

                        let productRegistration = new ProductRegistration(data, elements);
                        productRegistration.populateEmbeddedForm();
                    }
                });
    })($$epiforms || $);
}
